import { formatCurrency } from '@/pages/table/utils/utils';
import CurrencyIcon from '@/components/CurrencySymbolMask/CurrencyIcon';
import React, { FC } from 'react';

interface CurrencyLabelProps {
  amount: number | undefined;
  shouldDisplayInBB: boolean;
  bigBlindValue: number;
  hideCurrencyIcon?: boolean;
  shortCurrencyFormat?: boolean;
  mobileCurrencyFormat?: boolean;
}
const CurrencyLabel: FC<CurrencyLabelProps> = ({
  amount = 0,
  shouldDisplayInBB,
  bigBlindValue,
  hideCurrencyIcon = false,
  shortCurrencyFormat = false,
  mobileCurrencyFormat = false,
}) => {
  return shouldDisplayInBB && bigBlindValue ? (
    ` ${formatCurrency(amount / bigBlindValue)} BB`
  ) : (
    <span className="flex">
      {!hideCurrencyIcon && <CurrencyIcon />}
      {formatCurrency(amount, { shortFormat: shortCurrencyFormat, mobileFormat: mobileCurrencyFormat })}
    </span>
  );
};

export default CurrencyLabel;
